import { useAppointmentState, useAppointmentUpdateAndPersist } from '../../../../context/Appointment/appointment';
import { CTAButton } from '../../../../controls/ButtonBase';
import { useLocalization } from '../../../../context/Localization/localization';
import { DataBox } from '../../../../controls/DataBox/DataBox';
import { Heading } from '../../../../controls/Heading/Heading';
import { ScrollableBody } from '../../../Layout/ScrollableBody/ScrollableBody';
import { ICaptureResults } from './LicenseScanIndex';
import { useKioskState } from '../../../../context/Kiosk/kiosk';
import { Country } from '../../../../API/Enums';
import { GMButtonGroup } from '../../../../controls/ButtonGroup';
import { GMRoundedIcon, GMSizedIcon } from '../../../../controls/Icon';

export interface IProps {
    results?: ICaptureResults;
    onInformationCorrect: () => void;
    onInformationIncorrect: () => void;
}

export const Confirm = (props: IProps) => {
    const Localization = useLocalization();
    const setAppointment = useAppointmentUpdateAndPersist();
    const appointment = useAppointmentState();

    const results = { ...appointment,
        ...props.results };

    const {
        dealer: { country },
    } = useKioskState();
    const stateOrProvinceLocalized = country === Country.Canada ? Localization.Province : Localization.State;
    const postalCodeLocalized = country === Country.Canada ? Localization.PostalCode : Localization.ZipCode;

    const dataItems = [
        { title: Localization.FirstName,
            value: results.firstName },
        { title: Localization.LastName,
            value: results.lastName },
        { title: Localization.Street,
            value: results.street },
        { title: Localization.City,
            value: results.city },
        { title: stateOrProvinceLocalized,
            value: results.stateOrProvince },
        { title: postalCodeLocalized,
            value: results.postalCode },
    ];

    const onProceed = () => {
        setAppointment({
            ...appointment,
            ...results,
            licenseStatus: 'scanned',
        });
        props.onInformationCorrect();
    };

    return (
        <ScrollableBody
            heading={
                <Heading
                    primaryHeading={Localization.ConfirmTheScan}
                    secondaryHeading={Localization.IsTheInformationBelowCorrect}
                    roundedIcon={
                        <GMRoundedIcon themeType={'secondary'} roundedBackgroundSize={'large'}>
                            <GMSizedIcon
                                iconType={'License'}
                                iconSize={'extraLarge'}
                                ariaLabel={Localization.DriversLicenseIcon}
                            />
                        </GMRoundedIcon>
                    }
                    showMustache
                />
            }
            proceedButtons={
                <GMButtonGroup
                    buttons={[
                        (
                            <CTAButton
                                styleType={'primary'}
                                onClick={onProceed}
                                title={Localization.ClickToConfirmCorrect}
                                label={Localization.YesItIs}
                                id={Localization.ClickToConfirmCorrect}
                                ariaLabel={Localization.ClickToConfirmCorrect}
                            />
                        ),
                        (
                            <CTAButton
                                styleType={'secondary'}
                                onClick={props.onInformationIncorrect}
                                title={Localization.ClickToReturnToEntry}
                                label={Localization.NoItIsNot}
                                ariaLabel={Localization.ClickToReturnToEntry}
                                id={Localization.ClickToReturnToEntry}
                            />
                        ),
                    ]}
                />
            }
        >
            <DataBox dataItems={dataItems} />
        </ScrollableBody>
    );
};
